export const CARD_APPLY = 'card_apply';
export const CARD_ACTIVATE = 'card_activate';
